/**
 * Firebase decodes the URLs automatically
 * and we couldn't find a solution for it
 * on the server-side, so it makes sense
 * to encode the URLs twice like I'm
 * doing below.
 *
 * Example of the problem:
 *
 * Value: "http://198.13.34.191/watch"
 * Encoded once (won't work): https://qa-advantage.mandiant.com/indicator/url/http%3A%2F%2F198.13.34.191%2Fwatch
 * Encoded twice (should work): https://qa-advantage.mandiant.com/indicator/url/http%253A%252F%252F198.13.34.191%252Fwatch
 *
 * The encoded once value won't work because Firebase decodes it
 * and redirects you to https://qa-advantage.mandiant.com/indicator/url/http://198.13.34.191/watch
 * which results in an invalid path.
 */
export const encodeURIComponentTwice = (str) => {
  return encodeURIComponent(encodeURIComponent(str))
}
